var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideBarArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2513_5627)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.73712 1.23419C2.77196 1.19927 2.81334 1.17156 2.8589 1.15266C2.90446 1.13375 2.9533 1.12402 3.00262 1.12402C3.05195 1.12402 3.10079 1.13375 3.14635 1.15266C3.19191 1.17156 3.23329 1.19927 3.26812 1.23419L7.76812 5.73419C7.80305 5.76903 7.83075 5.81041 7.84966 5.85597C7.86856 5.90153 7.87829 5.95037 7.87829 5.99969C7.87829 6.04902 7.86856 6.09786 7.84966 6.14342C7.83075 6.18898 7.80305 6.23036 7.76812 6.26519L3.26812 10.7652C3.19771 10.8356 3.10221 10.8752 3.00262 10.8752C2.90304 10.8752 2.80754 10.8356 2.73712 10.7652C2.66671 10.6948 2.62715 10.5993 2.62715 10.4997C2.62715 10.4001 2.66671 10.3046 2.73712 10.2342L6.97237 5.99969L2.73712 1.76519C2.7022 1.73036 2.67449 1.68898 2.65559 1.64342C2.63668 1.59786 2.62695 1.54902 2.62695 1.49969C2.62695 1.45037 2.63668 1.40153 2.65559 1.35597C2.67449 1.31041 2.7022 1.26903 2.73712 1.23419Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.73712 1.23419C5.77196 1.19927 5.81334 1.17156 5.8589 1.15266C5.90446 1.13375 5.9533 1.12402 6.00262 1.12402C6.05195 1.12402 6.10079 1.13375 6.14635 1.15266C6.19191 1.17156 6.23329 1.19927 6.26812 1.23419L10.7681 5.73419C10.803 5.76903 10.8308 5.81041 10.8497 5.85597C10.8686 5.90153 10.8783 5.95037 10.8783 5.99969C10.8783 6.04902 10.8686 6.09786 10.8497 6.14342C10.8308 6.18898 10.803 6.23036 10.7681 6.26519L6.26812 10.7652C6.19771 10.8356 6.10221 10.8752 6.00262 10.8752C5.90304 10.8752 5.80754 10.8356 5.73712 10.7652C5.66671 10.6948 5.62715 10.5993 5.62715 10.4997C5.62715 10.4001 5.66671 10.3046 5.73712 10.2342L9.97237 5.99969L5.73712 1.76519C5.7022 1.73036 5.67449 1.68898 5.65559 1.64342C5.63668 1.59786 5.62695 1.54902 5.62695 1.49969C5.62695 1.45037 5.63668 1.40153 5.65559 1.35597C5.67449 1.31041 5.7022 1.26903 5.73712 1.23419Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2513_5627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarArrow);
export default __webpack_public_path__ + "static/media/side-bar-arrow.fb35a786dad16f6dfa9eb4b659cbd128.svg";
export { ForwardRef as ReactComponent };